<div class="container mt-4">

  <div class="card p-4 mb-4">

    <h5>Add Language</h5>

    <form (ngSubmit)="addLanguage()">

      <div class="row">

        <div class="col-md-2 mb-3">

          <label>Short Code</label>

          <input class="form-control" [(ngModel)]="newLanguage.LanguageShortCode" name="newLangCode" maxlength="45" required />

        </div>

        <div class="col-md-3 mb-3">

          <label>Language Name</label>

          <input class="form-control" [(ngModel)]="newLanguage.LanguageName" name="newLangName" maxlength="200" required />

        </div>

        <div class="col-md-2 mb-3">

          <label>Script name</label>

          <input class="form-control" [(ngModel)]="newLanguage.ScriptName" name="newScriptName" maxlength="200"

            placeholder="e.g. Devanagari" />

        </div>

        <div class="col-md-2 mb-3">

          <label>Keep technical words in English?</label>

          <select class="form-select" [(ngModel)]="newLanguage.KeepTechnicalInEnglish" name="newKeepTech">

            <option value="Y">Yes</option>

            <option value="N">No</option>

          </select>

        </div>

        <div class="col-md-2 mb-3">

          <label>Technical word script</label>

          <select class="form-select" [(ngModel)]="newLanguage.TechnicalEnglishScript" name="newTechScript"

            [disabled]="newLanguage.KeepTechnicalInEnglish === 'N'">

            <option value="ROMAN">Roman (Latin)</option>

            <option value="NATIVE">Native language script</option>

          </select>

        </div>

        <div class="col-md-5 mb-3">

          <label>Custom translation instruction</label>

          <textarea class="form-control" rows="2" [(ngModel)]="newLanguage.TranslationInstruction" name="newLangInstr"

            placeholder="e.g. Hinglish style; conversational tone for training slides"></textarea>

        </div>

        <div class="col-md-2 mb-3 d-flex align-items-end">

          <button class="btn btn-primary w-100" type="submit">Add Language</button>

        </div>

      </div>

    </form>

  </div>



  <div class="card p-3 mb-3">

    <div class="row">

      <div class="col-md-6">

        <label>Search</label>

        <input class="form-control" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"

          placeholder="Search code, name, or instruction" />

      </div>

      <div class="col-md-6 d-flex align-items-end text-muted small">

        {{ filteredLanguages.length }} of {{ languageList.length }} language(s)

      </div>

    </div>

  </div>



  <div class="card p-3">

    <h5>Language Master</h5>

    <div *ngIf="loading">Loading…</div>

    <div *ngIf="error" class="text-danger">{{ error }}</div>



    <table class="table table-bordered table-hover" *ngIf="!loading">

      <thead class="table-light">

        <tr>

          <th>

            <button type="button" class="btn btn-link p-0 text-decoration-none fw-semibold" (click)="setSort('LanguageShortCode')">

              Short Code{{ sortIndicator('LanguageShortCode') }}

            </button>

          </th>

          <th>

            <button type="button" class="btn btn-link p-0 text-decoration-none fw-semibold" (click)="setSort('LanguageName')">

              Name{{ sortIndicator('LanguageName') }}

            </button>

          </th>

          <th>Script</th>

          <th>Keep tech in EN</th>

          <th>Tech script</th>

          <th>Custom Instruction</th>

          <th style="width:8rem">Actions</th>

        </tr>

      </thead>

      <tbody>

        <tr *ngFor="let lang of filteredLanguages">

          <ng-container *ngIf="editingCode !== lang.LanguageShortCode; else editRowTpl">

            <td>{{ lang.LanguageShortCode }}</td>

            <td>{{ lang.LanguageName }}</td>

            <td>{{ lang.ScriptName }}</td>

            <td>{{ lang.KeepTechnicalInEnglish || 'Y' }}</td>

            <td>{{ lang.KeepTechnicalInEnglish === 'N' ? '—' : (lang.TechnicalEnglishScript || 'ROMAN') }}</td>

            <td class="small">{{ lang.TranslationInstruction }}</td>

            <td>

              <button type="button" class="btn btn-sm btn-outline-primary" (click)="startEdit(lang)">Edit</button>

            </td>

          </ng-container>

          <ng-template #editRowTpl>

            <td>{{ lang.LanguageShortCode }}</td>

            <td><input class="form-control form-control-sm" [(ngModel)]="editRow.LanguageName" /></td>

            <td><input class="form-control form-control-sm" [(ngModel)]="editRow.ScriptName" placeholder="Devanagari" /></td>

            <td>

              <select class="form-select form-select-sm" [(ngModel)]="editRow.KeepTechnicalInEnglish">

                <option value="Y">Y</option>

                <option value="N">N</option>

              </select>

            </td>

            <td>

              <select class="form-select form-select-sm" [(ngModel)]="editRow.TechnicalEnglishScript"

                [disabled]="editRow.KeepTechnicalInEnglish === 'N'">

                <option value="ROMAN">ROMAN</option>

                <option value="NATIVE">NATIVE</option>

              </select>

            </td>

            <td><textarea class="form-control form-control-sm" rows="2" [(ngModel)]="editRow.TranslationInstruction"></textarea></td>

            <td>

              <button type="button" class="btn btn-sm btn-success me-1" (click)="saveEdit()">Save</button>

              <button type="button" class="btn btn-sm btn-secondary" (click)="cancelEdit()">Cancel</button>

            </td>

          </ng-template>

        </tr>

        <tr *ngIf="filteredLanguages.length === 0">

          <td colspan="7" class="text-muted text-center">No languages found.</td>

        </tr>

      </tbody>

    </table>

  </div>

</div>

